// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"291":"dacbabb42e5b1ef0","578":"0a0bdbf430e0360f","744":"492606f10a64989b","988":"ead25ed1a7594a4d"}[chunkId] + ".js";
};